import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import type {
  ImageCapturePage,
  ImageCapturePageType,
} from "@rumble-it/common-lib/types/models/ImageCapture.interface";

// Fetch a single ImageCapturePage by ID
export const fetchImageCapturePageById = async (
  id: string,
): Promise<ImageCapturePage> =>
  axiosInstance
    .get(`/admin/image-captures/pages/${id}`)
    .then((response) => response.data);

// Create a new ImageCapturePage
// Expects payload including relations as IRIs, e.g. { imageCapture: "/image-captures/{id}", type: "/image-captures/pagetypes/{id}", ... }
export const createImageCapturePage = async (
  data: Partial<ImageCapturePage> & { imageCapture: string; type: string },
): Promise<null> =>
  axiosInstance
    .post(`/admin/image-captures/pages`, data)
    .then((response) => response.data);

// Update an existing ImageCapturePage
export const updateImageCapturePageById = async (
  id: string,
  data: Partial<ImageCapturePage>,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/image-captures/pages/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

// Delete an ImageCapturePage
export const deleteImageCapturePageById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/image-captures/pages/${id}`)
    .then((response) => response.data);

// Fetch page types for select
export const fetchImageCapturePageTypes = async (): Promise<
  Array<ImageCapturePageType>
> =>
  axiosInstance
    .get(`/admin/image-captures/pagetypes`)
    .then((response) => response.data);
